<ng-container *transloco="let t; read: 'under-maintenance'">
    <header>
        <img src="assets/under-maintenance/header.gif" alt="{{t('justice-logo-alt')}}" width="100%">
    </header>
    <section>
        <div class="logo">
            <img src="assets/under-maintenance/logo.gif" alt="{{t('justice-logo-alt')}}">
            <img src="assets/under-maintenance/logo.gif" alt="{{t('justice-logo-alt')}}">
        </div>
        <div class="text"> from {{(from | date:'H') + ':' + (from | date:'mm')}} to {{(until | date:'H') + ':' + (until | date:'mm')}}</div>
        <img class="background" src="assets/under-maintenance/background.jpg" alt="{{t('justice-palace-alt')}}">
    </section>
    <footer>
        <div>{{t('footer')}}</div>
    </footer>
</ng-container>